define('views/blocks/CheckoutPaymentMethodView',['underscore', 'backbone', 'jquery', 'router', 'app', 'SubView',
    'models/EdenredDataModel',
    'views/blocks/EdenredSwitchView',
    'template!blocks/checkout/payment-method',
], function (_, Backbone, $, router, app, SubView,
             EdenredDataModel,
             EdenredSwitchView,
             paymentMethodTemplate
) {
    return Backbone.View.extend(SubView).extend({
        events: {
            'change [name=payment-method]': 'changePaymentMethod',
        },
        initialize: function () {

            var view = this,
                cart = app.getCart();
            view.subviews = [];
            view.listenTo(app, 'displayCheckoutPaymentMethodOption', view.displayCheckoutPaymentMethodOption);
            view.listenTo(cart, 'change:payment_restrictions_sum', view.updateProductPaymentRestrictions);
            view.listenTo(cart, 'changeContext change:product change:total_price_ttc amountReduceUpdate', view.render);
            view.initializeEdenred();
            view.listenTo(EdenredDataModel,'change',view.changeEdenred);
            var selectedPaymentMethod = view.getSelectedPaymentMethod();
            if (selectedPaymentMethod) {
                view.selectPaymentMethod(selectedPaymentMethod.id);
            }
        },

        render: function () {
            // on rend à nouveau en cas de changement de store
            var view = this,
                cart = app.getCart(),
                paymentMethods = cart.getPaymentMethods(),
                selectedPaymentMethod = view.getSelectedPaymentMethod(),
                selectedIndex = paymentMethods.findIndex({id_payment_method:selectedPaymentMethod.id}) || 0;
            view.$el.html(paymentMethodTemplate({
                paymentMethods: paymentMethods,
                selectedPaymentIndex:selectedIndex
            }));
            view.initializeEdenred();
            try {
                if (selectedPaymentMethod) {
                    view.selectPaymentMethod(selectedPaymentMethod.id);
                } else {
                    view.updateEdenred();
                }
            }catch(err){
            }
            view.delegateEvents();
        },

        getSelectedPaymentMethod:function(){
            var view = this, cart = app.getCart(),
                paymentMethods = cart.getPaymentMethods(),
                selectedPaymentMethod = view.selectedPaymentMethod || false;
            if(selectedPaymentMethod && selectedPaymentMethod.hasRestriction(cart)) selectedPaymentMethod = false;
            paymentMethods.each(function(paymentMethod){
                if(!selectedPaymentMethod && !paymentMethod.hasRestriction(cart)){
                    selectedPaymentMethod = paymentMethod;
                }
            });
            // on ne devrait pas avoir de valeur non défini.
            if(!selectedPaymentMethod){app.error()}
            return selectedPaymentMethod;
        },

        initializeEdenred:function(){
            var view = this, edenredSwitch;

            if(!EdenredDataModel.hasPM()){
                // si edenred n'est pas disponible
                return;
            }
            edenredSwitch = new EdenredSwitchView();
            view.$('.payment').before(edenredSwitch.el);
            view.attachView(edenredSwitch);
        },

        changeEdenred:function(){
            if(!EdenredDataModel.hasPM()){
                // si edenred n'est pas disponible
                return;
            }
            var view = this,
                selectedPaymentMethod = view.selectedPaymentMethod,
                edenredPaymentMethod = EdenredDataModel.getPaymentMethod();
            if(EdenredDataModel.isActive()){
                if(EdenredDataModel.requireAltPM()){
                    if(selectedPaymentMethod && (edenredPaymentMethod.id === selectedPaymentMethod.id)){
                        // si on a besoin d'une méthode de paiement et qu'on active edenred,
                        // il n'est pas la méthode de paiement sélectionné
                        selectedPaymentMethod = false;
                    }
                }else{
                    selectedPaymentMethod = edenredPaymentMethod;
                }
            }else if(selectedPaymentMethod && (edenredPaymentMethod.id === selectedPaymentMethod.id)){
                selectedPaymentMethod = false;
            }
            view.selectedPaymentMethod = selectedPaymentMethod;
            view.render();
        },

        updateEdenred:function(){
            if(!EdenredDataModel.hasPM()){
                // si edenred n'est pas disponible
                return;
            }
            var view = this,
                $payment = view.$('.payment'),
                paymentVisible = true,
                edenredPaymentMethod = EdenredDataModel.getPaymentMethod(),
                edenredLineEl = view.$('.payment .check-group[data-id="'+edenredPaymentMethod.id+'"]');
            if(EdenredDataModel.displaySwitch()){
                edenredLineEl.hide();
                paymentVisible = EdenredDataModel.requireAltPM() || !EdenredDataModel.isActive();
                if(!paymentVisible){
                    view.setPaymentMethod(EdenredDataModel.getPaymentMethod().id);
                }
            }else{
                $payment.show();
                edenredLineEl.show();
            }
            $payment.toggleClass('hidden',!paymentVisible);

        },

        updateProductPaymentRestrictions: function () {
            var view = this,
                resetSelection = false,
                paymentMethods = app.getCart().getPaymentMethods();
            paymentMethods.each(function (paymentMethod, index) {
                var $paymentMethod = view.$('.payment .check-group').eq(index),
                    input = $paymentMethod.find('input:radio'),
                    hasRestriction = paymentMethod.hasRestriction();
                    // supprime le message disabled
                    $paymentMethod.find('.label-disabled').remove();
                    // active / désactive le radio button
                    $paymentMethod.toggleClass("group-disabled", hasRestriction);
                    if(input.is(':checked') && hasRestriction){
                        // si le radio était selectionné et desactivé,
                        // on doit réinitialiser une selection
                        resetSelection = true;
                    }
                    input.prop("disabled", hasRestriction);
                if (hasRestriction) {
                    // recharge le message de restriction
                    $paymentMethod.find('label').append("<span class='label-disabled'>" + paymentMethod.getRestrictionMessage() + "</span>");
                }
            });
            if(resetSelection){
                var input = view.$('.payment .check-group input:radio:not(:disabled):first');
                input.prop('checked',true);
                view.selectPaymentMethod(input.val());
            }

        },

        changePaymentMethod: function (e) {
            this.selectPaymentMethod(e.currentTarget.value);
        },
        selectPaymentMethod: function (id) {
            this.setPaymentMethod(id);
            this.updateEdenred();
        },
        setPaymentMethod: function(id){
            var view = this, cart = app.getCart(),
                paymentMethod = cart.getPaymentMethod(id);
            if(!paymentMethod){
                paymentMethod = cart.getPaymentMethods().first();
            }
            paymentMethod.next();
            // force radio value
            view.$('[name="payment-method"][value="'+id+'"]').attr('checked',true);
            view.selectedPaymentMethod = paymentMethod;
            //
            cart.usePaymentMethod(paymentMethod);
        },

        displayCheckoutPaymentMethodOption: function (paymentView) {
            var view = this,
                currentPaymentView = view.paymentView,
                paymentMethodOptions = view.$('.payment-method-options');
            if (currentPaymentView && paymentView!==currentPaymentView) {
                view.detachView(currentPaymentView);
            }
            if (paymentView) {
                view.paymentView = view.attachView(paymentView);
                paymentMethodOptions.html(paymentView.el);
                paymentView.render();
            }
        }


    });


});
